import React, { useEffect, useState } from 'react'
import { Header } from '../header/Header'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import './userHome.scss'
import { zynity_website } from '../../config/external-routes'
import { Body } from './bodyV2/Body'
import { ErrorBoundary } from './ErrorBoundary';
import { constants } from '../../config/constants'
import { getUserOrganizations } from "../../store/user_organizations"
// @ts-ignore
import Cookies from 'js-cookie'
import MyHomepageIcon from '../../assets/images/my_homepage_icon.svg';

export const UserHome2 = () => {
  const dispatch = useDispatch();
  const yii_url = zynity_website.yii_website_url;
  const user = useSelector((state: any) => state.auth);

  // Gate rendering until we know whether the cookie exists (prevents flash)
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const access_token = Cookies.get(constants.zynity_api_access_token_cookie_name) || user?.access_token;
    if (!access_token) {
      // Do not render; just leave the page after redirect
      window.location.replace('/site/login');
      return;
    }

    // Safe to render
    document.title = `My Homepage | ${constants.website_title}`;
    dispatch(getUserOrganizations());
    setReady(true);
  }, [dispatch, user?.access_token]);

  function profileCheckMsg(user: any) {
    let url = `${zynity_website.yii_website_url}/people/update/id/${user.id}`;
    let msg = `Your profile is incomplete of basic information. <a href="${url}">Click Here</a> to complete now.`;
    if (user.first_name == '' || user.last_name == '' || user.know_as == '' || user.time_zone == '') {
      return msg;
    }
    return false;
  }

  function coachProfileCheckMsg(user: any) {
    const coach = user.coach;
    if (!coach) return false;

    let url = `${zynity_website.yii_website_url}/CertifiedCoach/ccUpdate/id/${coach.id}`;
    let msg = `Please review your Coaches profile for basic current information. <a href="${url}">Click Here</a> to complete now.`;
    if (coach.FirstName == '' || coach.LastName == '' || coach.Type == '') {
      return msg;
    }
    return false;
  }

  // Prevents the quick paint + redirect flash
  if (!ready) return null;

  return (
    <>
      <Header />

      <div className="container mt-3">
        <ErrorBoundary>
        {
          profileCheckMsg(user) &&
          <div className="row">
            <div className="col userHomeMessage" dangerouslySetInnerHTML={{ __html: profileCheckMsg(user) }}></div>
          </div>
        }

        {
          coachProfileCheckMsg(user) &&
          <div className="row">
            <div className="col userHomeMessage" dangerouslySetInnerHTML={{ __html: coachProfileCheckMsg(user) }}></div>
          </div>
        }
        <Body />
        </ErrorBoundary>
      </div>
    </>
  )
}
